<template>
    <div :id="id" class="slide" :class="{ 'active': slide.active }">
        <div class="slide-content">
            <div v-html="slide.content"></div>
        </div>
    </div>
</template>
<script>
    import {TimelineLite, TweenLite, Linear} from 'gsap';

    export default {
        props: [ 'slide', 'index', 'entering', 'leaving' ],
        methods: {
            enterTransition() {
                let timeline = new TimelineLite()
                    .set( this.$el, { opacity: 1, left: (100 * this.slide.direction)+'%' } )
                    .to( this.$el, .5, { left: '0%', ease: Linear.easeNone } )
                    .call( () => { this.$emit('enterDone', this.index, this.slide.direction) } )
            },
            leavingTransition() {
                let timeline = new TimelineLite()
                    .to( this.$el, .5, { left: (-100 * this.slide.direction)+'%', ease: Linear.easeNone }, 0 )
                    .call( () => {
                        TweenLite.set( this.$el, { opacity: 0 } );
                        this.$emit('leavingDone', this.index, this.slide.direction)
                    } )
            }
        },
        computed: {
            id() {
                return 'slide-0'+(this.index + 1)
            }
        },
        watch: {
            entering( state ) {
                if( state ) this.enterTransition()
            },
            leaving( state ) {
                if( state ) this.leavingTransition()
            }
        }
    }
</script>